export default __webpack_public_path__ + "3b96a7d08161ba5b861f3d35e7898230.png";